import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface User {
  id: string;
  accountId: string;
  firstName: string;
  lastName: string;
  email: string;
  permissions: Array<string>;
  isTeamLead: boolean;
}

interface AuthState {
  token: string;
  user: User;
  profilePicture: string | undefined;
}

const initialState = {
  token: "",
  user: {},
} as AuthState;

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setCurrentUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    setUserProfilePicture: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.profilePicture = action.payload;
    },
  },
});

export const { setToken, setCurrentUser, setUserProfilePicture } =
  authSlice.actions;
